import * as React from 'react';
import {UIState} from "data/UIState";
import {PageEnums} from "components/nav/PageEnums";

import './ManagerPill.pcss';
import {ManagerIcon} from "components/widgets/icons/ManagerIcon";

interface Props {
}
export const ManagerPill = (props:Props) => {

  if(!UIState.user.isClientContact) {
    return null;
  } else {
    return (
      <div role={"button"} tabIndex={0}  className="manager-pill" aria-label={"Platform Admin"} onClick={()=>{ UIState.currentPage = PageEnums.hr; }} >
        <ManagerIcon />
        <span aria-hidden="true" className={"manager-button-text"}>Admin</span>
      </div>
    );
  }
}